var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7827 5.1991L10.8067 3.2212C9.45594 1.86911 8.78056 1.19307 8.05517 1.3531C7.32978 1.51314 7.00089 2.41074 6.34312 4.20595L5.89793 5.421C5.72257 5.89958 5.63489 6.13888 5.47714 6.32398C5.40636 6.40703 5.32583 6.48123 5.23728 6.54498C5.03996 6.68704 4.79447 6.75472 4.30348 6.89007C3.19685 7.19516 2.64354 7.3477 2.43503 7.70973C2.34489 7.86623 2.29799 8.04393 2.29913 8.22458C2.30177 8.64245 2.70759 9.04866 3.51923 9.8611L4.3522 10.6951L1.52517 13.5221C1.26489 13.7824 1.26489 14.2044 1.52517 14.4647C1.78545 14.7249 2.20745 14.7249 2.46773 14.4647L5.29439 11.638L6.15832 12.5028C6.97512 13.3204 7.38352 13.7292 7.80386 13.7298C7.98101 13.7301 8.15515 13.684 8.30904 13.5962C8.67421 13.3878 8.82757 12.8304 9.1343 11.7157C9.26915 11.2255 9.33658 10.9805 9.47812 10.7832C9.54008 10.6969 9.61197 10.6181 9.6923 10.5485C9.87579 10.3896 10.1135 10.3003 10.589 10.1217L11.818 9.65993C13.5935 8.99289 14.4812 8.65936 14.6376 7.93591C14.7941 7.21246 14.1236 6.54134 12.7827 5.1991Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.4cbb0dc87ccf5c33b847977de27eadaa.svg";
export { ForwardRef as ReactComponent };